import styled from "styled-components";
import React from "react";
import LottieLoader from "../components/loaders/LottieLoader";

const Container = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    min-width: 330px;
    align-items: center;
    min-height: 120px;
`;

class Loader extends React.Component {

    render() {

        return (
            <Container>
                <LottieLoader />
            </Container>
        );
    }
}
export default (Loader);
